import type { ImageProps } from 'next/image';
import NextImage from 'next/image';
import ViewportImage from './ViewportImage';
import { transformMediaUrl } from '@/lib/media-url-transformer';
import { ensureLargeMediaProxySize } from '@/lib/media-proxy-size';

export type MediaImageProps = ImageProps & {
  /** false = doğrudan yükle (Swiper/karusel gibi IO’nun güvenilmediği yerler) */
  viewportDefer?: boolean;
};

export default function MediaImage({
  viewportDefer = true,
  ...props
}: MediaImageProps) {
  const resolvedSrc =
    typeof props.src === 'string'
      ? (() => {
          const base = transformMediaUrl(props.src, null) || props.src;
          return ensureLargeMediaProxySize(base);
        })()
      : props.src;

  const resolvedUnoptimized =
    typeof resolvedSrc === 'string' && resolvedSrc.startsWith('/api/media/proxy/')
      ? true
      : props.unoptimized;

  const imageProps = { ...props, src: resolvedSrc, unoptimized: resolvedUnoptimized };
  if (!viewportDefer) {
    return <NextImage {...imageProps} />;
  }
  return <ViewportImage {...imageProps} />;
}
